import React, { useState ,useEffect} from 'react'
import {Row,Col,Form} from 'react-bootstrap'
import Header from '../Component/Header';
import PageHead from '../Component/pageHead';
import Footer from '../Component/footer';
import {useFormik} from 'formik';
import '../../node_modules/font-awesome/css/font-awesome.min.css'; 
import {PostAction} from '../Component/PostAction';
import { useHistory } from "react-router-dom";
import DataTables from '../Component/DataTables'
import {GetAction} from '../Component/GetAction';
import Loader from '../Component/Loader';
import PaymentReceipt from './PaymentReceipt';

function DonationHistory() {
    const [listData, setListData] = useState([]);
    const [loader, setLoader] = useState(true);
    const [modal, setModal] = useState(false);
    const [pdfData, setPDFData] = useState();
    const [autoDownload, setAutoDownload] = useState(false);
    let history = useHistory();
    const title = "Donation History"
    const tableTitle = "Donation List"
    const searchColumn = ""

    const openReceipt = (row, download = false) => {
        setPDFData(row)
        setAutoDownload(!!download)
        setModal(true)
    }

    const closeReceipt = () => {
        setModal(false)
        setAutoDownload(false)
    }

    const columns = [
    { name: "Sr.no", selector: (row) => row.index ,width:'5%'},
    { name: "Donation Type", selector: (row) => row.type_name, sortable: true },
    { name: "Mode Of Payment", selector: (row) => row.mode_of_payment, sortable: true},
    { name: "Amount", selector: (row) => row.payment_amount, sortable: true },
    { name: "Payment Date", selector: (row) => row.created_at, sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex flex-wrap gap-1">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => openReceipt(row, false)}
            title="View receipt"
          >
            View
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => openReceipt(row, true)}
            title="Download PDF receipt"
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true" /> PDF
          </button>
        </div>
      ),
      width: '18%',
    },
  ];
   useEffect(()=>{
    const userlAPI = async () => {
        const userUrl = `donation/DonationHistory`;
        let reqParam = {
            user_id:sessionStorage.getItem('id'),
        }
        const res = await GetAction('get',reqParam,userUrl)
        const response = await res.response
        setListData(response)
        setLoader(false)
        }
        userlAPI();
    },[]);
    
    if(!sessionStorage.getItem('id')){
    history.push('/Login');
    }

    if(loader){
        return(
        <>
        <Loader title={title} pageTitle={tableTitle} />
        
        </>
        );
      } 
  return (
    <>
    <Header />
    <PageHead title="Donation History" />
    <div className='container'  style={{fontSize:20,minHeight:"615px"}}>
    <DataTables columns={columns} title={tableTitle} searchColumn = {searchColumn} editAction="" deleteAction="" tvalue={listData}/>
    </div>
    {modal ? (
      <PaymentReceipt
        hide={closeReceipt}
        title={title}
        data={pdfData}
        autoDownload={autoDownload}
      />
    ) : null}
    <Footer />
    </>
  )
}

export default DonationHistory
